module.exports = __webpack_public_path__ + "img/mssrf.645d1b25.jpg";